import React, { useRef, useState, useEffect } from "react";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import "./leaveapproverstyle.css"; // Assuming this has your custom styles
import { baseurladdress } from "../baseurl";
import axios from "axios";
import $ from 'jquery'
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

function Leaveapproves() {

  const Swal = require('sweetalert2');
  const showToast = (icon, title) => {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon,
      title,
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
  };
  const accesstoken = localStorage.getItem("token");
  const userid = localStorage.getItem("id");

  // State for the temporary approver list being built in the card
  const [editConfig, setEditConfig] = useState(null);

  const [approverRows, setApproverRows] = useState([]);
  // State for the main table displaying existing configurations
  const [existingConfigurations, setExistingConfigurations] = useState([]);
  const [loading, setLoading] = useState(true);
  const tableRef = useRef(null);

  const [departments, setDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [approvalLevels, setApprovalLevels] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [staffSearchTerm, setStaffSearchTerm] = useState("");
  const [staffOptions, setStaffOptions] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);

  // State to control the visibility of the add approver card
  const [showAddApproverCard, setShowAddApproverCard] = useState(false);
  const [showEditApproverCard, setShowEditApproverCard] = useState(false);

  const getApproverRoleText = (isFinal) =>
    Number(isFinal) === 1 ? "Final Approver" : "Verification";
  const getApprovalLevelName = (levelId) => {
    const match = approvalLevels.find((item) => Number(item.Llevel_id) === Number(levelId));
    return match?.Llevel_rolename || null;
  };

  // --- API Calls ---

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(baseurladdress + `findalldept`, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      });
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setDepartments(response.data.response);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchBranches = async () => {
    try {
      const response = await axios.get(baseurladdress + `findallbranches`, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      });
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setBranches(Array.isArray(response.data?.response) ? response.data.response : []);
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBranches([]);
    }
  };

  const fetchStaffList = async () => {
    try {
      const response = await axios.get(baseurladdress + `findallstaff`, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      });
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setStaffList(Array.isArray(response.data?.response) ? response.data.response : []);
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaffList([]);
    }
  };

  const fetchExistingLeaveApprovers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${baseurladdress}findallleaveapprovers`,
        {
          // Replace with your actual endpoint
          headers: {
            Authorization: `Bearer ${accesstoken}`,
          },
        }
      );
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setExistingConfigurations(Array.isArray(response.data?.response) ? response.data.response : []);
    } catch (error) {
      console.error("Error fetching existing leave approvers:", error);
      setExistingConfigurations([]);
    } finally {
      setLoading(false);
    }
  };

  // --- useEffect Hooks ---

  useEffect(() => {
    fetchBranches();
    fetchDepartments();
    fetchApprovalLevels();
    fetchStaffList();
    fetchExistingLeaveApprovers(); // Fetch existing data on mount
  }, []);

  useEffect(() => {
    const normalizedSearch = staffSearchTerm.trim().toLowerCase();
    const selectedDeptObject = departments.find(
      (dept) => dept.dept_name === selectedDepartment
    );

    const filtered = staffList.filter((staff) => {
      const staffBranchId = String(staff.staff_placedat ?? staff.branch_id ?? "");
      const staffDeptId = String(staff.staff_department ?? staff.dept_id ?? "");
      const staffName = String(staff.staff_name ?? "").toLowerCase();
      const staffEmail = String(staff.staff_email ?? "").toLowerCase();

      const branchMatches =
        !selectedBranch || staffBranchId === String(selectedBranch);
      const departmentMatches =
        !selectedDeptObject || staffDeptId === String(selectedDeptObject.dept_id);
      const searchMatches =
        !normalizedSearch ||
        staffName.includes(normalizedSearch) ||
        staffEmail.includes(normalizedSearch);

      return branchMatches && departmentMatches && searchMatches;
    });

    setStaffOptions(filtered);
  }, [staffSearchTerm, selectedDepartment, selectedBranch, departments, staffList]);

 useEffect(() => {

  if (loading) return;

  let dataTable = null;

  const timer = setTimeout(() => {

    // destroy old instance
    if ($.fn.DataTable.isDataTable("#leaveapprovaltable")) {
      $("#leaveapprovaltable").DataTable().destroy();
    }

    // initialize new
    dataTable = $("#leaveapprovaltable").DataTable({
      destroy: true,
      responsive: true,
      pageLength: 10,
      autoWidth: false,
      searching: true,
      paging: true,
      ordering: true,
      info: true,
      retrieve: true,
      language: {
        emptyTable: "No leave approvers found",
        zeroRecords: "No matching records found",
      },
    });

  }, 300);

  return () => {

    clearTimeout(timer);

    if ($.fn.DataTable.isDataTable("#leaveapprovaltable")) {
      $("#leaveapprovaltable").DataTable().destroy();
    }

  };

}, [existingConfigurations, loading]);
  // --- Handlers ---

  const handleDepartmentChange = (event) => {
    const deptName = event.target.value;
    setSelectedDepartment(deptName);
    setStaffSearchTerm("");
    setStaffOptions([]);
    setSelectedStaff(null);
    setApproverRows([]); // Clear rows when department changes

    if (deptName && selectedBranch) {
      const alreadyExists = existingConfigurations.some(
        (config) =>
          String(config.LApr_branchid) === String(selectedBranch) &&
          Number(config.LApr_status ?? 1) === 1
      );
      if (alreadyExists) {
        showToast("warning", "An approver already exists for this branch.");
      }
    }
  };

  const handleBranchChange = (event) => {
    const branchId = event.target.value;
    setSelectedBranch(branchId);
    setSelectedDepartment("");
    setStaffSearchTerm("");
    setStaffOptions([]);
    setSelectedStaff(null);
    setApproverRows([]);

    if (branchId) {
      const alreadyExists = existingConfigurations.some(
        (config) =>
          String(config.LApr_branchid) === String(branchId) &&
          Number(config.LApr_status ?? 1) === 1
      );
      if (alreadyExists) {
        showToast("warning", "An approver already exists for this branch.");
      }
    }
  };


  const handleStaffSearchChange = (event) => {
    setStaffSearchTerm(event.target.value);
    setSelectedStaff(null);
  };

  const handleStaffSelect = (staff) => {
    if (approverRows.length >= 1) {
      showToast("warning", "Only one approver can be added for a branch.");
      return;
    }

    const alreadyExists = existingConfigurations.some(
      (config) =>
        String(config.LApr_branchid) === String(selectedBranch) &&
        Number(config.LApr_status ?? 1) === 1
    );
    if (alreadyExists) {
      showToast("warning", "An approver already exists for this branch.");
      return;
    }

    // Prevent adding duplicate staff members for the same department
    const isDuplicate = approverRows.some(
      (row) => row.staffid === staff.staff_id
    );
    if (isDuplicate) {
      showToast("warning", "This staff member is already added.");
      return;
    }

    setApproverRows((prev) => [
      ...prev,
      {
        id: prev.length,
        staffName: staff.staff_name,
        staffEmail: staff.staff_email,
        staffid: staff.staff_id,
        isFinal: 0,
        approvalLevel: "",
      },
    ]);
    setStaffSearchTerm("");
    setStaffOptions([]);
  };

  const handleFinalChange = (id, isChecked) => {
    setApproverRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === id) {
          return { ...row, isFinal: isChecked ? 1 : 0 };
        }
        return isChecked ? { ...row, isFinal: 0 } : row;
      })
    );
  };

  const fetchApprovalLevels = async () => {
    try {
      const response = await axios.get(`${baseurladdress}getallapprovallevels`, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      });
      setApprovalLevels(Array.isArray(response.data?.response) ? response.data.response : []);
    } catch (error) {
      console.error("Error fetching approval levels:", error);
      setApprovalLevels([]);
    }
  };

  const removeApproverRow = (id) => {
    setApproverRows(approverRows.filter((row) => row.id !== id));
  };

  const handleSaveApprovers = async () => {
    const currentSelectedDept = departments.find(
      (dept) => dept.dept_name === selectedDepartment
    );
    const departmentIdToSave = currentSelectedDept?.dept_id;
    const currentSelectedBranch = branches.find(
      (branch) => String(branch.branch_id) === String(selectedBranch)
    );

    if (!selectedBranch || !departmentIdToSave || approverRows.length === 0) {
      showToast("warning", "Please select a branch, department and add at least one approver.");
      return;
    }

    if (approverRows.length > 1) {
      showToast("warning", "Only one approver can be added for a branch.");
      return;
    }

    const alreadyExists = existingConfigurations.some(
      (config) =>
        String(config.LApr_branchid) === String(selectedBranch) &&
        Number(config.LApr_status ?? 1) === 1
    );
    if (alreadyExists) {
      showToast("warning", "An approver already exists for this branch.");
      return;
    }

    const hasMissingApprovalLevel = approverRows.some((row) => !row.approvalLevel);
    if (hasMissingApprovalLevel) {
      showToast("warning", "Please select an approval level for all approvers.");
      return;
    }

    
    const payload = {
      user: userid,
      branch_id: selectedBranch,
      branch_name: currentSelectedBranch?.branch_name || "",
      department_name: selectedDepartment,
      department_id: departmentIdToSave,
      approvers: approverRows.map((row) => ({
        staff_name: row.staffName,
        staff_email: row.staffEmail,
        staff_id: row.staffid,
        is_final: row.isFinal,
        approval_level: row.approvalLevel ? Number(row.approvalLevel) : null,
      })),
    };

    console.log("Sending data:", payload);

    try {
      const response = await axios.post(
        `${baseurladdress}saveleaveapprovers`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Approvers saved successfully!", response.data);
      showToast("success", "Leave approvers saved successfully.");
      // After successful save, clear the form and hide the card
      setApproverRows([]);
      setSelectedBranch("");
      setSelectedDepartment("");
      setStaffSearchTerm("");
      setSelectedStaff(null);
      setShowAddApproverCard(false); // Hide the card
      fetchExistingLeaveApprovers(); // Refresh the main table
    } catch (error) {
      console.error(
        "Error saving approvers:",
        error.response?.data || error.message || error
      );
      showToast(
        "error",
        `Failed to save approvers: ${error.response?.data?.message || error.message}`
      );
    }
  };


  const handleDeleteClick = (id) => {

  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085D6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {

    if (result.isConfirmed) {

      try {

        // destroy first
        if ($.fn.DataTable.isDataTable("#leaveapprovaltable")) {
          $("#leaveapprovaltable").DataTable().destroy();
        }

        const response = await axios.post(
          `${baseurladdress}deleteleaveapproval/${id}`,
          [],
          {
            headers: {
              Authorization: `Bearer ${accesstoken}`,
            },
          }
        );

        if (response.data.status === "deleted") {

          showToast("success", "Deleted Successfully");

          // update state
          setExistingConfigurations((prev) =>
            prev.filter((item) => item.LApr_id !== id)
          );

        } else {

          showToast("error", "Delete failed");

        }

      } catch (error) {

        console.error(error);

        showToast("error", "Delete failed");

      }

    }

  });

};
  const handleSaveEditApprover = async () => {
  try {
    if (!editConfig?.LApr_Llevelid) {
      showToast("warning", "Please select an approval level.");
      return;
    }

    const updatedConfig = {
      ...editConfig,
      LApr_Llevelid: Number(editConfig.LApr_Llevelid),
      user_id: userid, // Add your user ID here
    };

    const response = await axios.put(
      `${baseurladdress}updateleaveapproval`,
      updatedConfig,
      {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
      }
    );

    showToast("success", "Updated successfully.");
    setShowEditApproverCard(false);
    setEditConfig(null);
    fetchExistingLeaveApprovers(); // Refresh the list
  } catch (err) {
    console.error(err);
    showToast("error", "Failed to update.");
  }
  };

  



  // --- Render Logic ---

  return (
    <div>
      <Topnavbar />
      <Sidennav />
      <div className="content-wrap">
        <div className="container-fluid">
          {/* Conditional Card for Adding/Editing Approvers (Moved to Top) */}

          {showEditApproverCard && (
            <div className="card mt-3 mb-3 p-2">
              <div className="card-header py-2 px-3 d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Edit</h5>

                <div className="d-flex align-items-center">
                  {/* Save & Close buttons - moved here as requested */}
                  <button
                    className="btn btn-primary btn-sm mr-2 px-3 py-1"
                    onClick={handleSaveEditApprover}
                  >

                    <i className="fa fa-save mr-1"></i> Save
                  </button>

                  <button
                    className="btn btn-secondary btn-sm px-3 py-1"
                    onClick={() => {
                      setShowEditApproverCard(false);
                      setEditConfig(null);
                    }}
                  >
                    <i className="fa fa-times mr-1"></i> Close
                  </button>
                </div>
              </div>

              <div className="card-body py-2 px-3">
                <div className="d-flex flex-wrap align-items-end">
                  <div
                    className="mr-3 mb-2 flex-grow-1"
                    style={{ maxWidth: "200px" }}
                  >
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Department
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editConfig?.LApr_deptname || ""}
                      readOnly
                      style={{ fontSize: "0.85rem", backgroundColor: "#f8f9fa" }} // light gray bg for clarity
                    />
                  </div>

                  {/* Name */}
                  <div
                    className="mr-3 mb-2 flex-grow-1"
                    style={{ maxWidth: "300px" }}
                  >
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editConfig?.LApr_staffname || ""}
                      readOnly
                      style={{ fontSize: "0.85rem" ,backgroundColor: "#f8f9fa" }}
                    />
                  </div>

                  {/* Branch */}
                  <div
                    className="mr-3 mb-2 flex-grow-1"
                    style={{ maxWidth: "220px" }}
                  >
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Branch
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editConfig?.LApr_branchname || ""}
                      readOnly
                      style={{ fontSize: "0.85rem", backgroundColor: "#f8f9fa" }}
                    />
                  </div>

                  {/* Email */}
                  <div
                    className="mr-3 mb-2 flex-grow-1"
                    style={{ maxWidth: "350px" }}
                  >
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Email
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editConfig?.LApr_email || ""}
                      onChange={(e) =>
                        setEditConfig((prev) => ({
                          ...prev,
                          LApr_email: e.target.value,
                        }))
                      }
                      style={{ fontSize: "0.85rem" }}
                    />
                  </div>

                  <div
                    className="mr-3 mb-2 flex-grow-1"
                    style={{ maxWidth: "220px" }}
                  >
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Role Level
                    </label>
                    <select
                      className="form-control form-control-sm"
                      value={editConfig?.LApr_Llevelid ?? ""}
                      onChange={(e) =>
                        setEditConfig((prev) => ({
                          ...prev,
                          LApr_Llevelid: e.target.value ? Number(e.target.value) : "",
                        }))
                      }
                    >
                      <option value="">Select Level</option>
                      {approvalLevels.map((level) => (
                        <option key={level.Llevel_id} value={level.Llevel_id}>
                          {level.Llevel_rolename}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Status Checkbox */}
                  <div className="mr-3 mb-2">
                    <div
                      className="form-check form-switch d-flex align-items-center"
                      style={{ minHeight: "38px" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="statusToggle"
                        checked={editConfig?.LApr_status === 1}
                        onChange={(e) =>
                          setEditConfig((prev) => ({
                            ...prev,
                            LApr_status: e.target.checked ? 1 : 0,
                          }))
                        }
                      />

                      <label
                        className="form-check-label ml-2"
                        htmlFor="statusToggle"
                        style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}
                      >
                        Active
                      </label>
                    </div>
                  </div>

                  {/* Final Checkbox */}
                  <div className="mb-2">
                    <div
                      className="form-check d-flex align-items-center"
                      style={{ minHeight: "38px" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="statusToggle"
                        checked={editConfig?.LApr_final === 1}
                        onChange={(e) =>
                          setEditConfig((prev) => ({
                            ...prev,
                            LApr_final: e.target.checked ? 1 : 0,
                          }))
                        }
                      />

                      <label
                        className="form-check-label ml-2"
                        htmlFor="finalCheckbox"
                        style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}
                      >
                        Final Approver
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showAddApproverCard && (
            <div className="card mt-4 mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5>Add</h5>
                <div className="d-flex">
                  <button
                    className="btn btn-primary btn-sm mr-2" // Add right margin to the first button
                    onClick={handleSaveApprovers}
                    disabled={approverRows.length === 0 || !selectedBranch || !selectedDepartment}
                  >
                    <i className="fa fa-save mr-1"></i> SAVE
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setShowAddApproverCard(false);
                      setApproverRows([]);
                      setSelectedBranch("");
                      setSelectedDepartment("");
                      setStaffSearchTerm("");
                      setSelectedStaff(null);
                    }}
                  >
                    <i className="fa fa-times mr-1"></i> Close
                  </button>
                </div>
              </div>

              <div className="card-body">
                {/* Adjusted column widths for better alignment */}
                <div className="row mb-3 align-items-end">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label
                        htmlFor="branch"
                        className="form-label"
                        style={{ fontSize: "0.85rem" }}
                      >
                        Branch:
                      </label>
                      <select
                        id="branch"
                        className="form-control"
                        value={selectedBranch}
                        onChange={handleBranchChange}
                        style={{ fontSize: "0.9rem" }}
                      >
                        <option value="" style={{ fontSize: "0.9rem", color: "#aaa" }}>
                          Select Branch
                        </option>
                        {branches.map((branch) => (
                          <option
                            key={branch.branch_id}
                            value={branch.branch_id}
                            style={{ fontSize: "0.9rem" }}
                          >
                            {branch.branch_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    {" "}
                    {/* Increased to col-md-5 */}
                    <div className="form-group">
                      <label
                        htmlFor="department"
                        className="form-label"
                        style={{ fontSize: "0.85rem" }}
                      >
                        Department:
                      </label>
                      <select
                        id="department"
                        className="form-control"
                        value={selectedDepartment}
                        onChange={handleDepartmentChange}
                        style={{ fontSize: "0.9rem" }}
                        disabled={!selectedBranch}
                      >
                        <option
                          value=""
                          style={{ fontSize: "0.9rem", color: "#aaa" }}
                        >
                          Select Department
                        </option>
                        {departments.map((dept) => (
                          <option
                            key={dept.dept_id}
                            value={dept.dept_name}
                            style={{ fontSize: "0.9rem" }}
                          >
                            {dept.dept_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    {" "}
                    {/* Increased to col-md-5 */}
                    <div className="form-group">
                      <label
                        htmlFor="staff"
                        className="form-label"
                        style={{ fontSize: "0.85rem" }}
                      >
                        Staff Search:
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          id="staff"
                          className="form-control "
                          placeholder="Type staff name or email"
                          value={staffSearchTerm}
                          onChange={handleStaffSearchChange}
                          style={{ fontSize: "0.9rem" }}
                          disabled={!selectedBranch || !selectedDepartment}
                        />
                        {staffOptions.length > 0 && staffSearchTerm && selectedBranch && selectedDepartment && (
                          <ul
                            className="list-group position-absolute w-100"
                            style={{
                              zIndex: 1000,
                              maxHeight: "200px",
                              overflowY: "auto",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              top: "calc(100% + 5px)",
                            }}
                          >
                            {staffOptions.map((staff) => (
                              <li
                                key={staff.staff_id}
                                className="list-group-item list-group-item-action"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                }}
                                onClick={() => handleStaffSelect(staff)}
                              >
                                {staff.staff_name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* The save button column is removed from here as it's now in the card header */}
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>Name</th>
                        <th style={{ textAlign: "left" }}>Email</th>
                        <th style={{ textAlign: "left" }}>Final</th>
                        <th style={{ textAlign: "left" }}>Role</th>
                        <th
                          style={{ width: "80px",textAlign: "left" }}
                        >
                          Remove
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {approverRows.length > 0 ? (
                        approverRows.map((row, index) => (
                          <tr key={row.id}>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={row.staffName}
                                readOnly
                                style={{
                                  fontSize: "0.9rem",
                                  backgroundColor: "transparent",
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={row.staffEmail}
                                  onChange={(e) => {
                                    const newEmail = e.target.value;
                                    setApproverRows((prevRows) =>
                                      prevRows.map((r) =>
                                        r.id === row.id ? { ...r, staffEmail: newEmail } : r
                                      )
                                    );
                                  }}
                                style={{
                                  fontSize: "0.9rem",
                                  backgroundColor: "transparent",
                                }}
                              />
                            </td>
                            <td className="align-middle">
                              <div className="d-flex justify-content-center align-items-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={row.isFinal === 1}
                                  onChange={(event) =>
                                    handleFinalChange(
                                      row.id,
                                      event.target.checked
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td className="align-middle">
                              <select
                                className="form-control form-control-sm"
                                value={row.approvalLevel || ""}
                                onChange={(e) => {
                                  const selectedLevel = e.target.value;
                                  setApproverRows((prevRows) =>
                                    prevRows.map((r) =>
                                      r.id === row.id ? { ...r, approvalLevel: selectedLevel } : r
                                    )
                                  );
                                }}
                              >
                                <option value="">Select Level</option>
                                {approvalLevels.map((level) => (
                                  <option key={level.Llevel_id} value={level.Llevel_id}>
                                    {level.Llevel_rolename}
                                  </option>
                                ))}
                              </select>
                            </td>

                            <td className="text-center align-middle">
                              <i
                                className="text-danger fa fa-trash"
                                style={{ cursor: "pointer", fontSize: "1.1em" }}
                                onClick={() => removeApproverRow(row.id)}
                              ></i>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center text-muted">
                            Start by selecting a department and searching for
                            staff to add.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* Main Table for Existing Configurations */}



          {!showEditApproverCard && !showAddApproverCard && (
              <div className="card mt-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4>Leave Approvers</h4>
                  <button
                    type="button"
                    className="btn plus-icon d-flex align-items-center"
                    onClick={() => {
                      setShowEditApproverCard(false);
                      setEditConfig(null);
                      setShowAddApproverCard(true);
                    }}
                    disabled={showAddApproverCard}
                    style={{ marginRight: "50px" }}
                  >
                    <span style={{ fontSize: "1.2rem" }}>
                      <i className="fa fa-plus-circle text-success"></i>
                    </span>
                    <span
                      style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}
                    >
                      Add
                    </span>
                  </button>
                </div>
                <div className="card">
                  <div className="card-body">
                    {loading ? (
                      <div className="d-flex flex-column align-items-center justify-content-center text-center py-5 px-3" style={{ minHeight: "260px" }}>
                        <div className="d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: "64px", height: "64px", backgroundColor: "#eef4ff", color: "#2f5bea", fontSize: "1.6rem" }}>
                          <i className="fa fa-refresh"></i>
                        </div>
                        <h5 className="mb-2" style={{ color: "#2f3b52" }}>Loading leave approvers...</h5>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered table-responsive-sm" id='leaveapprovaltable' ref={tableRef}>
                          <thead>
                            <tr>
                              <th scope="col">Sl.No</th>
                              <th scope="col">Name</th>
                              <th scope="col">Department</th>
                              <th scope="col">Email</th>
                              <th scope="col">Role Level</th>
                              <th scope="col">Edit</th>
                              <th scope="col">Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            {existingConfigurations.map((config, index) => (
                              <tr key={config.LApr_id || index}>
                                <td style={{ color: '#868e96' }}>{index + 1}</td>
                                <td>{config.LApr_staffname}</td>
                                <td>{config.LApr_deptname}</td>
                                <td>{config.LApr_email}</td>
                                <td>
                                  {config.LApr_Llevelid ? (
                                    getApprovalLevelName(config.LApr_Llevelid) || `Level ${config.LApr_Llevelid}`
                                  ) : (
                                    getApproverRoleText(config.LApr_final)
                                  )}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <i
                                    className="text-primary fa fa-edit"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditConfig(config);
                                      setShowEditApproverCard(true);
                                      setShowAddApproverCard(false);
                                    }}
                                  ></i>
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <i
                                    className="text-danger fa fa-trash"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      handleDeleteClick(config.LApr_id);
                                    }}
                                  ></i>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Leaveapproves;
